export default {
	settleList: [
		{
			label: 'A类',
			value: 1
		},
		{
			label: 'B类',
			value: 2
		},
		{
			label: 'C类',
			value: 3
		}
	]
}
